import { render, staticRenderFns } from "./ResidencyProofInput.vue?vue&type=template&id=779257e1&scoped=true"
import script from "./ResidencyProofInput.vue?vue&type=script&lang=js"
export * from "./ResidencyProofInput.vue?vue&type=script&lang=js"
import style0 from "./ResidencyProofInput.vue?vue&type=style&index=0&id=779257e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779257e1",
  null
  
)

export default component.exports